module.exports = __webpack_public_path__ + "static/media/ALLYGN_LOGO_START_SCREEN.8b43fb2d.svg";